import { Injectable } from '@angular/core';
import { ParamMap } from '@angular/router';
import { ReplaySubject } from 'rxjs';
import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';
import { FilterOptions } from './interface';

// WARNING: Don't change these because user's with a link to the public store will rely on them.
enum QueryParamConfigKeys {
  // HIDE_LMI determines whether or not to show the lmi section at all.
  HIDE_LMI = 'hide_filter',

  // Filters to determine whether or not to show the specific category, should default to true.
  // Defaulting to true maintains backwards compatibility with Partners who have no query params on the url.
  SHOW_ALL_FILTER = 'show_all_filter',
  SHOW_LISTING_FILTER = 'show_listing_filter',
  SHOW_SOCIAL_FILTER = 'show_social_filter',
  SHOW_REPUTATION_FILTER = 'show_reputation_filter',
  SHOW_SEO_FILTER = 'show_seo_filter',
  SHOW_WEBSITE_FILTER = 'show_website_filter',
  SHOW_ADVERTISING_FILTER = 'show_advertising_filter',
  SHOW_CONTENT_AND_EXPERIENCE = 'show_content_and_experience',
  RESTRICT_FILTERS_BY_PACKAGES = 'restrict_filters_by_packages',
}

@Injectable({
  providedIn: 'root',
})
export class StyleConfigService {
  private readonly queryParams$$: ReplaySubject<ParamMap> = new ReplaySubject(1);

  get showLmi$(): Observable<boolean> {
    return this.queryParams$$.pipe(
      map((queryParams) => {
        return queryParams.get(QueryParamConfigKeys.HIDE_LMI) !== 'true';
      }),
    );
  }

  get filterOptions$(): Observable<FilterOptions> {
    return this.queryParams$$.pipe(
      map((queryParams) => {
        return {
          showAllFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_ALL_FILTER),
          ),
          showListingFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_LISTING_FILTER),
          ),
          showSocialFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_SOCIAL_FILTER),
          ),
          showReputationFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_REPUTATION_FILTER),
          ),
          showSEOFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_SEO_FILTER),
          ),
          showWebsiteFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_WEBSITE_FILTER),
          ),
          showAdvertisingFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_ADVERTISING_FILTER),
          ),
          showContentAndExperienceFilter: this.convertStringToBooleanDefaultingToTrue(
            queryParams.get(QueryParamConfigKeys.SHOW_CONTENT_AND_EXPERIENCE),
          ),

          restrictFiltersToPackages: this.convertStringToBooleanDefaultingToFalse(
            queryParams.get(QueryParamConfigKeys.RESTRICT_FILTERS_BY_PACKAGES),
          ),
        } as FilterOptions;
      }),
    );
  }

  private convertStringToBooleanDefaultingToTrue(val: string | undefined | null): boolean {
    if (!val) {
      return true;
    }
    return val !== 'false';
  }

  private convertStringToBooleanDefaultingToFalse(val: string | undefined): boolean {
    if (!val) {
      return false;
    }
    return val === 'true';
  }

  setQueryParams(queryParamMap: ParamMap): void {
    this.queryParams$$.next(queryParamMap);
  }
}
